import {ethers} from 'ethers';
import {useState, useEffect} from 'react';
import web3Modal from './helper/connect';
import nftAxios from "./helper/axios";
import loadingMask from "./helper/loading";

function App(props) {
    const [provider, setProvider] = useState();
    const [library, setLibrary] = useState();
    const [account, setAccount, ] = useState();
    const [signature, setSignature] = useState("");
    const [error, setError] = useState("");
    const [chainId, setChainId] = useState();
    const [network, setNetwork] = useState();
    const [message, setMessage] = useState("");
    const [signedMessage, setSignedMessage] = useState("");
    const [verified, setVerified] = useState();
    const [to, setTo] = useState('')
    const [avatar, setAvatar] = useState('')

    //判断是否有钱包连接的缓存
    useEffect(() => {
        if (web3Modal.cachedProvider) {
            connectCheckWallet();
        }
    }, []);

    useEffect(() => {
        if (provider?.on) {
            const handleAccountsChanged = (accounts) => {
                console.log("accountsChanged", accounts);
                if (accounts) setAccount(accounts[0]);
            };

            const handleDisconnect = () => {
                console.log("disconnect", error);
                disconnect();
            };

            provider.on("accountsChanged", handleAccountsChanged);
            provider.on("disconnect", handleDisconnect);

            return () => {
                if (provider.removeListener) {
                    provider.removeListener("accountsChanged", handleAccountsChanged);
                    provider.removeListener("disconnect", handleDisconnect);
                }
            };
        }
    }, [provider]);

    const disconnect = async () => {
        await web3Modal.clearCachedProvider();
        refreshState();
    };

    const refreshState = () => {
        setAccount();
        setChainId();
        setNetwork("");
        setMessage("");
        setSignature("");
        setVerified(undefined);
        setLibrary("")
        nftAxios("/login/logout" );
        window.location.reload();
    };

    const connectCheckWallet = async () => {
        try {
            const provider = await web3Modal.connect();

            const library = new ethers.providers.Web3Provider(provider);
            const accounts = await library.listAccounts();

            const network = await library.getNetwork();
            setProvider(provider);
            setLibrary(library);
            if (accounts) {
                setAccount(accounts[0])
            }
            setNetwork(network);

            if (accounts[0]) {
                const avatar = await library.getAvatar(accounts[0]);
                console.log(avatar)
                let result = nftAxios("/login/login", {hash_key: accounts[0], avatar: avatar});
                result.then(res => {
                    if (res.data.result && res.data.result.code == 200) {
                        window.location.reload();
                    } else if(res.data.error == 10002) {
                        disconnect();
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
    };


    const connectWallet = async () => {
        try {
            let errorMsg = "";
            const provider = await web3Modal.connect();

            loadingMask.open();

            const library = new ethers.providers.Web3Provider(provider);
            const accounts = await library.listAccounts();

            const network = await library.getNetwork();
            setProvider(provider);
            setLibrary(library);
            if (accounts) {
                setAccount(accounts[0])
            }
            setNetwork(network);

            if (accounts[0]) {
                const avatar = await library.getAvatar(accounts[0]);
                console.log(avatar)
                let result = nftAxios("/login/login", {hash_key: accounts[0], avatar: avatar});
                result.then(res => {
                    if (res.data.result && res.data.result.code == 200) {
                        loadingMask.close();
                        window.location.reload();
                    } else if(res.data.error == 10002) {
                        disconnect();
                    }
                });
            }
        } catch (error) {
            console.log(error)
            loadingMask.close();
            console.log(error.toString())
            if (error.toString() == "Error: -32002") {
                loadingMask.show();
            } else {
                disconnect();
            }
        }
    };

    return (
        <div className="App">
            {!library &&
            <button onClick={connectWallet}>Connect Wallet</button>
            }
            {/*{library && <div>{avatar &&<img src={avatar}/>}</div>}*/}
            {library && <div>Wallet Address: ${account}</div>}
        </div>
    );
}

export default App;
